import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c8acb8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "api-goods" }
const _hoisted_2 = { class: "api-goods-title" }
const _hoisted_3 = { class: "title flex-ter" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = {
  class: "container",
  style: {"height":"500px"}
}

import { t } from '@/plugins/i18n'
import { ref } from 'vue'
import Search from '../Search.vue'
import NoGoods from '../NoGoods.vue'
import ShopGoodItem from './ShopGoodItem.vue'
import ApiGoodsDrawer from './ApiGoodsDrawer.vue'
import PlatformGoodsDrawer from '../PlatformGoods/PlatformGoodsDrawer.vue'
import { getCustomerShopPlatform, useRtfix } from '@/store'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: ['shopDetail', 'isAuth', 'productList', 'add', 'height', 'loading'],
  emits: ['change', 'delete'],
  setup(__props, { emit: emits }) {

const props = __props


const router = useRouter()
const apiGoodsFrawerRef = ref()
const platformGoodsDrawerRef = ref()
const keyword = ref('')
const search = () => {
  if (!props.isAuth) {
    ElMessage.warning(t('请先去授权'))
    return
  }
  apiGoodsFrawerRef.value.open(keyword.value)
}

const getShopId = (shopId:string) => {
  emits('change', shopId)
}
const similarSearch = (url:string) => {
  platformGoodsDrawerRef.value.open('', '1', 'transparent', url)
}
const change = () => {
  if (props.isAuth) {
    apiGoodsFrawerRef.value.open('')
    return
  }
  router.push(useRtfix('AuthorizedStore'))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getCustomerShopPlatform)() === '-' ? '': _unref(getCustomerShopPlatform)()) + " " + _toDisplayString(_unref(t)('api商品')), 1),
          _createElementVNode("span", {
            class: "link",
            onClick: search
          }, _toDisplayString(_unref(t)('选择已同步商品')) + ">", 1)
        ]),
        _createVNode(Search, {
          style: {"max-width":"576px"},
          placeholder: _unref(t)('请输入商品名3'),
          onSearch: search,
          value: keyword.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event))
        }, null, 8, ["placeholder", "value"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (__props.shopDetail.thirdItemCode && __props.isAuth)
          ? (_openBlock(), _createBlock(ShopGoodItem, {
              key: 0,
              shopDetail: __props.shopDetail,
              productList: __props.productList,
              onSimilar: similarSearch,
              onDelete: _cache[1] || (_cache[1] = ($event: any) => (emits('delete'))),
              height: __props.height
            }, null, 8, ["shopDetail", "productList", "height"]))
          : (!__props.loading)
            ? (_openBlock(), _createBlock(NoGoods, {
                key: 1,
                type: __props.isAuth ? 'authorizationSelection': 'unauthorized',
                onChange: change
              }, null, 8, ["type"]))
            : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(ApiGoodsDrawer, {
      ref: (_value, _refs) => {
        _refs['apiGoodsFrawerRef'] = _value
        apiGoodsFrawerRef.value = _value
      },
      onChange: getShopId
    }, null, 512),
    _createVNode(PlatformGoodsDrawer, {
      ref: (_value, _refs) => {
        _refs['platformGoodsDrawerRef'] = _value
        platformGoodsDrawerRef.value = _value
      },
      thirdItemCode: __props.shopDetail.thirdItemCode,
      add: __props.add
    }, null, 8, ["thirdItemCode", "add"])
  ], 64))
}
}

})